// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"296":"40a61ac1","787":"ef519ece"}[chunkId] + ".chunk.js";
};